import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";

export const StyledExportToggle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid ${colorsPalettes.carbon[50]};
    padding: 25px 0;
`;

export const StyledExportSwitchContainer = styled.div`
    display: flex;
`;

export const StyledExportLabel = styled.div`
    ${setFontVariant("body1")};
    color: ${colorsPalettes.carbon[400]};
    margin-left: 5px;
    text-transform: capitalize;
    line-height: 20px;
`;

export const StyledMandatoryFieldsWarning = styled.span`
    ${setFontVariant("body2")};
    color: ${colorsPalettes.red["s100"]};
    margin: 0 24px 0 auto;
`;

export const StyledMappedFields = styled.div`
    ${setFontVariant("body2")};
    color: ${colorsPalettes.carbon[400]};
    line-height: 16px;
`;

export const StyledLockedState = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledLockIcon = styled(SWReactIcons)`
    path {
        fill: ${colorsPalettes.carbon[100]}!important;
    }
`;
